import React, { useState } from 'react';
import { Link } from 'gatsby';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';
import moment from 'moment';

const News = () => {
  const query = graphql`
    {
      allStrapiBlogs {
        nodes {
          id
          slug
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
          date
          title
          category
        }
      }
    }
  `;
  const data = useStaticQuery(query);

  const {
    allStrapiBlogs: { nodes },
  } = data;

  const [term, setTerm] = useState('');
  const [filterData, setFilteredData] = useState([]);

  const handleInput = (e) => {
    const filteredData = nodes.filter((node) => {
      return node.title.toLowerCase().includes(term.toLowerCase());
    });
    setTerm(e.target.value);
    setFilteredData(filteredData);
  };

  const hasSearchResults = term && filterData;
  const news = hasSearchResults ? filterData : nodes;

  return (
    <section className='blog-one'>
      <div className='container'>
        <div className='sidebar__single sidebar__search'>
          <div className='sidebar__search-form'>
            <input
              type='text'
              name='search'
              placeholder='Search here...'
              value={term}
              onChange={handleInput}
            />
            <button type='submit' style={{ cursor: 'none' }}>
              <i className='fa fa-search'></i>
            </button>
          </div>
        </div>
        <div className='row'>
          {news?.map((node) => {
            return (
              <div
                className='col-lg-4 col-md-6 col-sm-12 wow fadeInUp'
                key={node.id}
              >
                <div className='blog-one__single'>
                  <div className='blog-one__image'>
                    <Image
                      fluid={node.image.childImageSharp.fluid}
                      alt={node.title}
                    />{' '}
                    <Link
                      to={`/blog/${node.category}/${node.slug}`}
                      className='blog-one__more-link'
                    >
                      <i className='fa fa-link'></i>
                    </Link>
                  </div>
                  <div className='blog-one__content'>
                    <ul className='list-unstyled blog-one__meta'>
                      <li>
                        <a href='#none'>
                          {moment(node.date).format('DD MMM, YYYY')}
                        </a>
                      </li>
                    </ul>
                    <h3 className='blog-one__title'>
                      <Link to={`/blog/${node.category}/${node.slug}`}>
                        {node.title}
                      </Link>
                    </h3>
                    <Link
                      to={`/blog/${node.category}/${node.slug}`}
                      className='blog-one__link'
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
export default News;
